import { useState, useRef } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import api from "../../api/api";
import "bootstrap/dist/css/bootstrap.min.css";
import ReCAPTCHA from "react-google-recaptcha";
import { RECAPTCHA_SITE_KEY, GOOGLE_AUTH_URL } from "../../config";





export default function Register() {

  const [form, setForm] = useState({
  name: "",
  phone: "",
  email: "",
  password: "",
  confirmPassword: "",
  userType: "PUBLIC"
});


  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [captchaToken, setCaptchaToken] = useState(null);
  const recaptchaRef = useRef();
  const navigate = useNavigate();
  const location = useLocation();


  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };
 const handleGoogleRegister = () => {
  window.location.href = GOOGLE_AUTH_URL;
};


  
const handleSubmit = async (e) => {
  e.preventDefault();

  if (!captchaToken) {
    setError("Please complete the captcha");
    return;
  }

  if (form.password !== form.confirmPassword) {
    setError("Passwords do not match");
    return;
  }

  setLoading(true);
  setError("");

  try {
    await api.post("/api/public/auth/register", {
      name: form.name,
      phone: form.phone,
      email: form.email,
      password: form.password,
      userType: form.userType,
      captchaToken: captchaToken   // IMPORTANT

    });

    setSuccess("Registered successfully! Redirecting...");
    const redirectTo = location.state?.from || "/login";
        setTimeout(() => {
        navigate(redirectTo);
        }, 1200);
  } catch (err) {
    setError(err.response?.data?.message || "Registration failed");
  } finally {
    setLoading(false);
  }
};



 return (
  <div className="container-fluid min-vh-100 d-flex align-items-center justify-content-center bg-light">
    <div
      className="shadow-lg rounded-4 bg-white p-4 w-100"
      style={{ maxWidth: "520px" }}
    >
      {/* Heading */}
      <h2 className="text-center mb-1">
        Join <span className="text-success">Orgavitaz</span>
      </h2>
      <p className="text-center text-muted mb-4">
        Create your account to explore our products and services.
      </p>

      {error && <div className="alert alert-danger">{error}</div>}
      {success && <div className="alert alert-success">{success}</div>}

      <form onSubmit={handleSubmit}>
  <div className="row">
    
    {/* LEFT COLUMN */}
    <div className="col-md-6">
      {/* Name */}
      <div className="mb-3">
        <label>Name</label>
        <input
          type="text"
          name="name"
          className="form-control"
          placeholder="Enter your name"
          value={form.name}
          onChange={handleChange}
          required
        />
      </div>

      {/* Email */}
      <div className="mb-3">
        <label>Email</label>
        <input
          type="email"
          name="email"
          className="form-control"
          placeholder="Enter email"
          value={form.email}
          onChange={handleChange}
          required
        />
      </div>

      {/* Password */}
      <div className="mb-3">
        <label>Password</label>
        <input
          type="password"
          name="password"
          className="form-control"
          placeholder="Enter password"
          value={form.password}
          onChange={handleChange}
          required
        />
      </div>
    </div>

    {/* RIGHT COLUMN */}
    <div className="col-md-6">
      {/* Phone */}
      <div className="mb-3">
        <label>Phone</label>
        <input
          type="tel"
          name="phone"
          className="form-control"
          placeholder="Enter phone"
          value={form.phone}
          onChange={handleChange}
          required
        />
      </div>

      {/* User Type */}
      <div className="mb-3">
        <label>User Type</label>
        <select
          name="userType"
          className="form-select"
          value={form.userType}
          onChange={handleChange}
          required
        >
          <option value="PUBLIC">Public</option>
          <option value="DISTRIBUTOR">Distributor</option>
          <option value="CLIENT">Client</option>
        </select>
      </div>

      {/* Confirm Password */}
      <div className="mb-3">
        <label>Confirm Password</label>
        <input
          type="password"
          name="confirmPassword"
          className="form-control"
          placeholder="Re-enter password"
          value={form.confirmPassword}
          onChange={handleChange}
          required
        />
      </div>
    </div>
  </div>

  {/* CAPTCHA */}
  <div className="mb-3 d-flex justify-content-center">
    <ReCAPTCHA
      ref={recaptchaRef}
      sitekey={RECAPTCHA_SITE_KEY}
      onChange={(token) => setCaptchaToken(token)}
      onExpired={() => setCaptchaToken(null)}
    />
  </div>

  {/* BUTTON */}
    <button
        type="submit"
        className="btn btn-success w-100 mb-3"
        disabled={loading}
    >
        {loading ? "Registering..." : "Register"}
    </button>
    </form>


      <div className="text-center mb-2">or</div>

      <button
        className="btn btn-outline-danger w-100 mb-3"
        onClick={handleGoogleRegister}
      >
        Continue with Google
      </button>

      <p className="text-center">
        Already have an account?{" "}
        <Link to="/login" className="text-decoration-none">
          Login
        </Link>
      </p>
    </div>
  </div>
);
}